module.exports = __webpack_public_path__ + "static/media/verdeGun.daa2dc8e.jpg";